// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/activities/swiper.less
// module id = 395
// module chunks = 0